/**
 * 根据登录时下发的 dataScopeAll / allowedDeptIds 判断客户是否可见。
 * 兼容旧版 localStorage（仅有 department、无 allowedDeptIds）。
 */
export function canViewCustomer(customer, user) {
  if (!user) return false
  if (user.username === 'admin') return true
  if (user.dataScopeAll) return true
  const deptId = customer && customer.manager && customer.manager.department && customer.manager.department.id
  if (deptId == null) return false
  const ids = user.allowedDeptIds
  if (Array.isArray(ids) && ids.length > 0) {
    return ids.indexOf(deptId) !== -1
  }
  return !!(user.department && user.department.id === deptId)
}

export function filterCustomersByDataPermission(customers, user) {
  if (!customers || !customers.length) return []
  if (!user) return []
  if (user.username === 'admin' || user.dataScopeAll) return customers.slice()
  return customers.filter(c => canViewCustomer(c, user))
}
